import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import MobileNavbar from './MobileNavbar';

const MobileHeader = () => {
  const WealthHorizonLogo="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/MaxiomWealthLogo.svg";
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [activeSection, setActiveSection] = useState(null);
  const [activeSubsection, setActiveSubsection] = useState(null);
  const location = useLocation();
  const isNavigatingRef = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollHeight - window.innerHeight;
      const currentScroll = window.pageYOffset;
      const scrollPercentage = (currentScroll / totalScroll) * 100;
      setScrollProgress(scrollPercentage);
    };

    // Listen for custom event to open navbar dropdown with specific section/subsection
    const handleOpenDropdown = (event) => {
      const { section, subsection } = event.detail;
      
      if (section) {
        setActiveSection(section);
        if (typeof subsection === 'number') {
          setActiveSubsection(subsection);
        }
        // Automatically open the menu when this event is triggered
        if (!isNavigatingRef.current) {
          setIsMenuOpen(true);
          document.body.style.overflow = 'hidden';
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('openNavDropdown', handleOpenDropdown);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('openNavDropdown', handleOpenDropdown);
    };
  }, []);

  // Ensure mobile menu closes on route change (including back/forward navigation)
  useEffect(() => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'auto';
    setActiveSection(null);
    setActiveSubsection(null);
    isNavigatingRef.current = false;
  }, [location.pathname]);

  const toggleMenu = () => {
    if (!isNavigatingRef.current) {
      setIsMenuOpen(!isMenuOpen);
      // Prevent body scrolling when menu is open
      document.body.style.overflow = !isMenuOpen ? 'hidden' : 'auto';
    }
  };

  return (
    <header className="fixed top-0 left-0 w-full shadow-md z-50" style={{ background: 'linear-gradient(135deg, #E8EEF6 0%, #FFFFFF 50%, #A2B8D8 100%)' }}>
      {/* Scroll Progress Bar */}
      <div className="absolute top-0 left-0 w-full h-[3px] bg-gray-100">
        <div
          className="h-full bg-[#006BA6] transition-width duration-200 ease-out"
          style={{ width: `${scrollProgress}%` }}
        />
      </div>

      <div className="flex justify-between items-center px-5 py-4 h-[60px]">
        <Link to="/" className="block">
          <img src={WealthHorizonLogo} alt="Wealth Horizon" className="h-10" />
        </Link>

        <button 
          className="flex flex-col justify-between w-6 h-[18px] bg-transparent border-none cursor-pointer p-0 z-[52]"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span className={`block w-full h-[2px] bg-gray-800 transition-all duration-300 ${
            isMenuOpen ? 'transform translate-y-[8px] rotate-45' : ''
          }`}></span>
          <span className={`block w-full h-[2px] bg-gray-800 transition-all duration-300 ${
            isMenuOpen ? 'opacity-0' : ''
          }`}></span>
          <span className={`block w-full h-[2px] bg-gray-800 transition-all duration-300 ${
            isMenuOpen ? 'transform -translate-y-[8px] -rotate-45' : ''
          }`}></span>
        </button>
      </div>

      {/* Only render MobileNavbar when isMenuOpen is true */}
      {isMenuOpen && (
        <MobileNavbar 
          isOpen={true} 
          closeMenu={() => {
            setIsMenuOpen(false);
            document.body.style.overflow = 'auto';
          }}
          activeSection={activeSection}
          activeSubsection={activeSubsection}
          setActiveSection={setActiveSection}
          setActiveSubsection={setActiveSubsection}
          isNavigatingRef={isNavigatingRef}
        />
      )}
    </header>
  );
};

export default MobileHeader;